import { useFormField } from '@american-autonomy/ag-ui';

import DatePicker from 'components/DatePicker';
import WithField from 'components/WithField';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FieldValues, Props } from './types';

const ServiceDateField = <T extends FieldValues>(props: Props<T>) => {
    const {
        className = '',
        control,
        isPlain,
        isRequired,
        name,
        placeholder,
        testId = TEST_ID
    } = props;

    const { SERVICE_DATE_FIELD_LABEL, SERVICE_DATE_IS_REQUIRED } = useTranslation();

    const {
        field: { onChange, ref, value }
    } = useFormField({
        control,
        name,
        rules: {
            required: isRequired ? SERVICE_DATE_IS_REQUIRED : false
        }
    });

    return (
        <WithField
            className={className}
            isPlain={isPlain}
            isRequired={isRequired}
            label={SERVICE_DATE_FIELD_LABEL}
            testId={testId}>
            <DatePicker
                isFutureAllowed={false}
                onChange={onChange}
                placeholder={placeholder}
                ref={ref}
                value={value}
            />
        </WithField>
    );
};

export default ServiceDateField;
